import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KioskConfigurationGridComponent } from './kiosk-configuration-grid/kiosk-configuration-grid.component';
import { KioskConfigurationSettingsComponent } from './kiosk-configuration-settings/kiosk-configuration-settings.component';
import {KioskRoutingModule} from './kiosk-configuration-routing.module';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DisableControlDirective } from './shared/directives/disable-control.directive';
@NgModule({
  declarations: [KioskConfigurationGridComponent, KioskConfigurationSettingsComponent,DisableControlDirective],
  imports: [
    CommonModule,
    KioskRoutingModule,
    InputsModule,
    GridModule,
    InputsModule,
    ButtonModule,
    HttpClientModule,
    ReactiveFormsModule,
    PopupModule,
    DropDownsModule,
    FormsModule,
    DialogsModule,
    SharedModule,
    NgMultiSelectDropDownModule
  ]
})
export class KioskConfigurationModule { }
